<template>
  <div class="order-processing-page">
    <transition
      :duration="{ enter: 800, leave: 10 }"
      name="fade"
    >
      <keep-alive>
        <component :is="currentVisibleComponent" />
      </keep-alive>
    </transition>
    <transition
      :duration="{ enter: 800, leave: 10 }"
      name="fade"
    >
      <component :is="currentOtherWindowComponent" />
    </transition>

    <!--    <create-client v-if="currentStep === 0" />
    <first-step v-if="currentStep === 1 && !currentOtherWindow && !showPromotionsWindow" />
    <second-step v-if="currentStep === 2 && !currentOtherWindow && !showPromotionsWindow" />

    <promotions-window v-if="showPromotionsWindow" />

    <modifications-window v-if="currentOtherWindow === 'modifications'" />
    <commentaries-window v-if="currentOtherWindow === 'commentaries'" />
    <preorder-window v-if="currentOtherWindow === 'preorder'" />
    <history-window v-if="currentOtherWindow === 'history'" />-->

    <transition name="fadeUp">
      <comment-keyboard v-show="showCommentKeyboard && currentStep === 2" />
    </transition>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import mixinSnackbarMessage from '@/mixins/snackbar-message'
  import CreateClient from '@/components/order-processing/order-components/create-client/CreateClient.vue'

  import FirstStep from '@/components/order-processing/order-components/FirstStep'
  import SecondStep from '@/components/order-processing/order-components/SecondStep'
  import ThirdStep from '@/components/order-processing/order-components/ThirdStep'

  import ModificationsWindow from '@/components/order-processing/order-components/modifications-window/ModificationsWindow'
  import CommentariesWindow from '@/components/order-processing/order-components/commentaries-window/CommentariesWindow'
  import PreorderWindow from '@/components/order-processing/order-components/preorder/PreorderWindow'
  import CommentKeyboard from '@/components/order-processing/new-order/keyboard/CommentKeyboard'
  import PromotionsWindow from '@/components/order-processing/order-components/first-step/PromotionsWindow'
  import HistoryWindow from '@/components/order-processing/order-components/history/HistoryWindow'
  import UpsalesWindow from '@/components/order-processing/order-components/upsales/UpsalesWindow.vue'

  export default {
    name: 'NewOrder',
    components: {
      ThirdStep,
      CreateClient,
      FirstStep,
      SecondStep,
      ModificationsWindow,
      CommentariesWindow,
      PreorderWindow,
      CommentKeyboard,
      PromotionsWindow,
      HistoryWindow,
    },
    mixins: [mixinSnackbarMessage],
    data () {
      return {
        curFilialId: null,
      }
    },
    computed: {
      ...mapState({
        basket: (state) => state.baskets.basket,
        currentOtherWindow: (state) => state.newOrder.currentOtherWindow,
        showPromotionsWindow: (state) => state.newOrder.showPromotionsWindow,
        currentStep: (state) => state.newOrder.currentStep,
        showCommentKeyboard: (state) => state.newOrder.showCommentKeyboard,
      }),
      currentOtherWindowComponent () {
        if (this.showPromotionsWindow) {
          return PromotionsWindow
        }
        switch (this.currentOtherWindow) {
          case 'modifications': return ModificationsWindow
          case 'commentaries': return CommentariesWindow
          case 'preorder': return PreorderWindow
          case 'history': return HistoryWindow
          case 'upsales': return UpsalesWindow
        }

        return null
      },
      currentVisibleComponent () {
        if (this.currentOtherWindowComponent) {
          return null
        }

        switch (this.currentStep) {
          case 0: return CreateClient
          case 1: return FirstStep
          case 2: return SecondStep
          case 3: return ThirdStep
        }

        return null
      },
    },
    watch: {
      currentOtherWindow (value) {
        if (value && this.showPromotionsWindow) {
          this.$store.commit('newOrder/togglePromotionsWindow')
        }
      },
      currentVisibleComponent () {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      },
      currentStep (val) {
        this.$store.commit('newOrder/closeOtherAndPromoWindows')
      },
      currentOtherWindowComponent () {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      },
      'basket.filial' (filial) {
        console.log('----filial watcher', filial?.id)
        const filialId = filial?.id
        const regionId = filial?.region?.id
        this.$store.commit('app/setRequestFilialId', filialId)
        this.$store.commit('app/setRequestRegionId', regionId)

        if (filialId && this.curFilialId !== filialId) {
          this.curFilialId = filialId
          this.getCategories()
        }
      },
    },
    created () {
      this.resetOrderData()
      this.$store.commit('newOrder/setPaymentMode', null)
      // заказ прошлого оформления не должен всплыть в диалоге оплаты после этой сессии
      this.$store.commit('orders/setCurrentOrderInfo', {})

      if (this.$route.query.id) {
        this.getBasket(this.$route.query.id)
      }
    },
    beforeDestroy () {
      this.resetOrderData()
      this.$store.commit('newOrder/setActiveClientId', null)
      this.$store.commit('newOrder/setNewClientPhone', null)
      this.$store.commit('newOrder/setNewOrderIncomingPhone', null)
    },
    methods: {
      getCategories () {
        this.$store.commit('newOrder/setMenuItemsLoading', true)
        // Получаем категории и добавляем их в стор
        this.$store
          .dispatch('categories/fetchFilialMenuCategoriesList', {
            limit: 10000,
            offset: 0,
            page: 1,
            hide_in_crm_items: 0,
          })
          .then((res) => {
            if (res.status === 200 && res.data.items.length) {
              // Добавляем категории в стор
              this.$store.commit('newOrder/setCategories', res.data.items || [])
              // Добавляем текующую категорию в стор
              this.$store.commit(
                'newOrder/setCurrentCategory',
                res.data.items[0].id,
              )
              // Добавляем элементы меню в стор
              this.$store.commit(
                'newOrder/setMenuItemsList',
                res.data.items[0].menuItems,
              )
              // Добавляем коллекции в стор
              this.$store.commit(
                'newOrder/setCollectionsList',
                res.data.items[0].collections,
              )
            }
          })
          .finally(() => {
            this.$store.commit('newOrder/setMenuItemsLoading', false)
          })
      },
      getClient () {
        this.$store
          .dispatch('clients/fetchSingleClients', this.$route.query.id)
          .then((res) => {
            if (res.status === 200) {
              const clientId = res.data.data.id
              this.$store.commit('newOrder/setCurrentClient', clientId)
              this.getBasket(clientId)
            } else {
              history.pushState({}, null, this.$route.path)
            }
          })
      },
      getBasket (id) {
        // Ищем корзину клиента
        this.$store
          .dispatch('baskets/fetchSingleBasket', id)
          .then((res) => {
            if (res.response && res.response.status === 404) {
              // Корзина оформлена/удалена извне - чистим плашку свёрнутого заказа
              if (this.$store.getters['collapsedOrders/byBasketId'](id)) {
                this.$store.commit('collapsedOrders/remove', id)
                this.showErrorMessage('Заказ уже оформлен или удалён')
              }
              history.pushState({}, null, this.$route.path)
            } else if (res.status === 200) {
              this.$store.commit('clients/setClientsSingle', res.data.data.client)
              this.$store.commit('baskets/setBasket', res.data.data)
              this.restoreStep(res.data.data.id)
            }
          })
      },
      restoreStep (basketId) {
        const collapsed = this.$store.getters['collapsedOrders/byBasketId'](basketId)
        const targetStep = collapsed ? collapsed.step : 1
        // Проходим шаги по порядку, чтобы наполнить availableSteps для степпера
        for (let step = 1; step <= targetStep; step++) {
          this.$store.commit('newOrder/setStep', step)
        }
      },
      resetOrderData () {
        this.$store.commit('orders/setCurrentEditOrder', {})
        // статус прошлого заказа (редактирование, оплата) блокирует смену филиала у новой корзины,
        // см. baskets/isFilialLocked - у нового заказа статуса быть не должно
        this.$store.commit('baskets/setOrderStatus', null)
        this.$store.commit('newOrder/resetAvailableSteps')
        this.$store.commit('newOrder/setStep', 0)
        this.$store.commit('newOrder/toggleResultWindow', false)
        this.$store.commit('newOrder/setDrinkDetailsStatus', false)
        this.$store.commit('newOrder/togglePromotionsWindow', false)
        this.$store.commit('newOrder/toggleCommentKeyboard', false)
        this.$store.commit('newOrder/setCurrentOtherWindow', undefined)
        this.$store.commit('newOrder/setSecondStepWindow', 'address')
        this.$store.commit('newOrder/setCurrentPaymentTab', 'paymentTypes')
        this.$store.commit('baskets/setBasket', {})
        this.$store.commit('newOrder/setMenuItemsList', [])
        this.$store.commit('newOrder/setCollectionsList', [])
        this.$store.commit('app/setRequestFilialId', null)
        this.$store.commit('app/setRequestRegionId', null)
        this.$store.commit('clients/setClientsAddress', [])
      },
    },
  }
</script>
